import { render, staticRenderFns } from "./Decorator.vue?vue&type=template&id=08658bf8&scoped=true&"
import script from "./Decorator.vue?vue&type=script&lang=js&"
export * from "./Decorator.vue?vue&type=script&lang=js&"
import style0 from "./Decorator.vue?vue&type=style&index=0&id=08658bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08658bf8",
  null
  
)

export default component.exports